import React, { useState, useEffect, useRef } from 'react';

// API
import axios from 'axios';
import { apiUrl } from '../../../config/apiConfig';
import api from '../../../services/api';

import { MdOutlineSend, Md360, MdWindow, MdBuild, MdLocalShipping, MdThumbDown, MdRestoreFromTrash, MdThumbUp, MdGrade, MdWhatsapp, MdOutlineEmail, MdArrowDropDown, MdArrowDropUp } from "react-icons/md";
import { format, parseISO } from 'date-fns';

// STYLE
import './style.css';

// CONTEXT API
import { useUser, user } from '../../../contexts/userContext';
import { useColumns } from '../../../contexts/columnsContext';
import { useCard } from '../../../contexts/cardContext'
import Logo from '../../../assets/logo-suite-flow.ico'

function Historic() {

  // CONTEXT API
  const { user, listAllUsers } = useUser();
  const { columnsUser } = useColumns();

  const { setOpenCloseUpdateCard, setCurrentCardData,
    setCards, setPreviewSearchCards,
    setListNotifications,
    setOpenCloseHistoricModal,
    setOpenCloseTarefasModal,
    setOpenCloseCompartilharModal,
    currentCardData
  } = useCard();


  // ESTADOS LOCAL
  const [currentHistoric, setCurrentHistoric] = useState('');

  const [history, setHistory] = useState([]);

  // Adicionar useEffect para lidar com a tecla ESC
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        setOpenCloseHistoricModal(false);
      }
    };

    window.addEventListener('keydown', handleEscKey);

    // Cleanup function para remover o event listener
    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  }, []);

  const [filterType, setFilterType] = useState(null); // 'Update', 'Mensagem' ou null
  const [onlyMyMessages, setOnlyMyMessages] = useState(false);





  useEffect(() => {
    const fetchHistory = async () => {


      try {
        // const response = await axios.get(`${apiUrl}/card/history/${currentCardData.card_id}`);
        const response = await api.get(`/card/history/${currentCardData.card_id}`);

        setHistory(response.data);

      } catch (error) {
        console.error('Error fetching history:', error);
      }
    };

    fetchHistory();
  }, [currentCardData.id, user.id]);

  // Historic Component in React

  const handleHistoric = async (event) => {
    event.preventDefault();
    if (!currentHistoric && currentHistoric == '')
      return;

    try {
      const payload = {
        card_id: currentCardData.card_id, // assuming idCard is available in the component's props
        user_id: user.id, // from useUser context
        action_type: 'Mensagem', // or any other type depending on the context
        description: currentHistoric,
        card_status: currentCardData.status, // assuming cardData has a status field
        empresa_id: user.empresa_id,
      };
      // const response = await axios.post(`${apiUrl}/card/add-history`, payload);
      const response = await api.post(`/card/add-history`, payload);

      setHistory(prevHistory => [...prevHistory, response.data]);
      setCurrentHistoric(''); // Reset input after submission

    } catch (error) {
      console.error('Error adding card history:', error);
    }
  };


  function formatDate(dateString) {
    const date = parseISO(dateString);
    return format(date, 'dd/MM/yyyy - HH:mm:ss');
  }


  const containerRef = useRef(null);

  useEffect(() => {
    const scrollContainer = containerRef.current;
    if (scrollContainer) {
      // Ajusta a posição de rolagem para o final do contêiner
      scrollContainer.scrollTop = scrollContainer.scrollHeight;
    }
  }, [history]);

  const getUserData = (userId) => {
    return listAllUsers.find(u => u.id === userId);
  };


  return (
    <div className='history-card-modal'>
      <div className='history-card-container'>
        <div className='history-card-footer'>
          <div className='header-update-card-container'>
            <label>Histórico</label>
          </div>
          <button className="history-card-close-button" onClick={() => { setOpenCloseHistoricModal(false) }}>X</button>
        </div>
        <div className="history-card-form-container">




          <div ref={containerRef} className='history-card-list-container'>


            {history
              .filter(item => !filterType || item.action_type === filterType)
              .filter(item => !onlyMyMessages || Number(item.user_id) === Number(user.id))
              .map((item) => (

                <div className='history-item-container' key={item.history_id}>
                  <div className='history-mensagem-container'>
                    <div className='user-logo-history-container'>
                      {/* <img src={getUserData(item.user_id)?.avatar || Logo} alt={getUserData(item.user_id)?.username || 'User'} className='user-logo-history' /> */}

                      <img
                        className='user-logo-history'
                        src={user && user.avatar ? (getUserData(item.user_id)?.avatar?.includes('syncs-avatar') ? require(`../../../assets/avatares/${getUserData(item.user_id).avatar}`) : getUserData(item.user_id).avatar) : Logo}
                      />

                    </div>
                    <p className='history-description' style={{ whiteSpace: 'pre-wrap' }}>{item.description}</p>
                  </div>
                  <p className='history-date'>{getUserData(item.user_id)?.username || ''}  -  {formatDate(item.create_at)}</p>
                </div>
              ))}

          </div>


          <div className="history-card-filters">
            <button
              className={`history-filter-btn ${filterType === 'Update' ? 'active' : ''}`}
              onClick={() => setFilterType(prev => prev === 'Update' ? null : 'Update')}
            >
              Sistema
            </button>
            <button
              className={`history-filter-btn ${filterType === 'Mensagem' ? 'active' : ''}`}
              onClick={() => setFilterType(prev => prev === 'Mensagem' ? null : 'Mensagem')}
            >
              Respostas
            </button>
            <button
              className={`history-filter-btn ${onlyMyMessages ? 'active' : ''}`}
              onClick={() => setOnlyMyMessages(prev => !prev)}
            >
              Minhas Mensagens
            </button>
          </div>

          <form className="history-card-form" >

            <textarea
              id="username"
              className="history-card-input"
              type="text"
              placeholder="Adicionar Histórico"
              value={currentHistoric}
              onChange={(e) => setCurrentHistoric(e.target.value)}
              rows={5} // Define a quantidade de linhas visíveis no textarea
              style={{ resize: 'none' }} // Evita que o usuário redimensione o textarea
            />

            <button style={{ backgroundColor: !currentHistoric.trim() ? '' : 'dodgerblue' }} type="submit" className="history-card-button" onClick={(event) => handleHistoric(event)} >
              <MdOutlineSend />

            </button>

          </form>
        </div>
      </div>
    </div>
  );
}

export default Historic; 
